var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.5C22.5 11.0147 24.5147 9 27 9H76.5C78.9853 9 81 11.0147 81 13.5V49.5H22.5V13.5Z",
    fill: "#21A366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45H22.5V63L54 69.3L81 63V45Z",
    fill: "#107C41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 63V76.5C22.5 79.2 24.75 81 27 81H76.5C79.2 81 81 79.2 81 76.5V63H22.5Z",
    fill: "#185C37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54 27H22.5V72H49.5C54.45 72 58.5 67.95 58.5 63V31.5C58.5 28.8 56.7 27 54 27Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 67.5H13.5C10.8 67.5 9 65.7 9 63V27C9 24.75 10.8 22.5 13.5 22.5H49.5C52.2 22.5 54 24.75 54 27V63C54 65.7 52.2 67.5 49.5 67.5Z",
    fill: "#107C41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3496 58.5L27.8996 45L20.2496 31.5H26.5496L31.0496 40.05C31.0496 40.95 31.4996 41.4 31.4996 41.85C31.9496 41.4 32.3996 40.5 32.8496 40.05L37.3496 31.5H43.1996L35.0996 45L43.6496 58.5H37.3496L31.9496 49.05C31.9496 48.6 31.4996 48.15 31.4996 47.7C31.4996 48.15 31.0496 48.6 31.0496 49.05L25.6496 58.5H19.3496Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81 13.5V27H54V9H76.5C78.75 9 81 11.25 81 13.5Z",
    fill: "#33C481"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExelIcon);
export default __webpack_public_path__ + "static/media/exel-icon.9520a4282e8e184d2c23b84a66d4e501.svg";
export { ForwardRef as ReactComponent };